import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { EmailEventInterface } from '../../../interfaces/interfaces';

export const getEmailEventsColumns = (
  setEventToDelete: (event: EmailEventInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setEventToUpdate: (event: EmailEventInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'eventName', headerName: 'Event Name', width: 250 },
  { field: 'subject', headerName: 'Subject', width: 300 },
  { field: 'templateName', headerName: 'Template', width: 200 },
  { field: 'description', headerName: 'Description', width: 350 },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setEventToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setEventToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];
